import { useEffect, useRef, useState } from "react";

/** Hydrate independently: an SWR mutation here would discard an in-flight GET. */
export function useCachedValue<T>(key: string | undefined, load: () => Promise<T | undefined>): T | undefined {
  const loader = useRef(load);
  loader.current = load;
  const [cached, setCached] = useState<{ key: string; value: T | undefined }>();
  useEffect(() => {
    if (!key) return;
    let active = true;
    void loader.current().then((value) => {
      if (active) setCached({ key, value });
    }).catch(() => undefined);
    return () => { active = false; };
  }, [key]);
  return cached?.key === key ? cached?.value : undefined;
}
